import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiGrid from '@material-ui/core/Grid';
import Link from 'next/link';
import PreisIcon from '../../../shared/icons/Preis';
import KomfortIcon from '../../../shared/icons/Komfort';
import KlimaIcon from '../../../shared/icons/Klima';
import HerkunftIcon from '../../../shared/icons/Herkunft';
import ZukunftIcon from '../../../shared/icons/Zukunft';
import FoerderprogrammIcon from '../../../shared/icons/Foerderprogramm';
import Wrap from '../../depi/sections/Wrap';

const ThemeCardTile = props => {
  const { title, text, icon, as } = props;
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;
  return (
    <MuiGrid item xs={12} sm={6} md={4}>
      <Box pb={6}>
        {icon && (
          <Box mb={1} textAlign="center">
            {icon}
          </Box>
        )}
        <Typography variant="h4" align="center" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h6" align="center" gutterBottom>
          {text}
        </Typography>
        <Box textAlign="center">
          <Link href={`${linkContext}[...pageId]`} as={as} passHref>
            <Typography component="a" variant="h6" color="primary">
              <b>Mehr erfahren</b>
            </Typography>
          </Link>
        </Box>
      </Box>
    </MuiGrid>
  );
};

const ThemeSection = () => {
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <Wrap>
      <Typography variant="h2" data-underline>
        Heizen mit Holzpellets
      </Typography>
      <Box mb={4}>
        <Typography variant="h6" align="center">
	  Das Heizen mit Holzpellets ist nicht nur wirtschaftlich und 
	  klimafreundlich, sondern auch einfach und komfortabel.
	</Typography>
      </Box>
      <MuiGrid container spacing={2}>
        <ThemeCardTile
          title="Herkunft"
          text="Holzpellets werden aus Holzspänen hergestellt, die im Sägewerk anfallen."
          icon={<HerkunftIcon fontSize="large" />}
          as={`${linkContext}pelletproduktion`}
        />
        <ThemeCardTile
          title="Klima"
          text={
            <React.Fragment>
              Pelletheizer sparen große Mengen des Treibhausgases CO<sub>2</sub>{' '}
              ein.
            </React.Fragment>
          }
          icon={<KlimaIcon fontSize="large" />}
          as={`${linkContext}klima-und-umwelt`}
        />
        <ThemeCardTile
          title="Förderprogramme"
	  text="Heizen mit Holzpellets wird staatlich gefördert – mind. 35 % Zuschuss"
          icon={<FoerderprogrammIcon fontSize="large" />}
          as={`${linkContext}foerderprogramme`}
        />
        <ThemeCardTile
          title="Zukunft"
          text="Holzpellets sind ein nachwachsender und daher klimafreundlicher Energieträger."
          icon={<ZukunftIcon fontSize="large" />}
          as={`${linkContext}pelletproduktion#5i764`}
        />
        <ThemeCardTile
          title="Preis"
          text="Holzpellets waren in den letzten zehn Jahren im Schnitt rund 30 % günstiger als Heizöl und Erdgas."
          icon={<PreisIcon fontSize="large" />}
          as={`${linkContext}pelletpreis-wirtschaftlichkeit`}
        />
        <ThemeCardTile
          title="Komfort"
          text="Auf Knopfdruck oder per App heizen: Pelletheizungen und Pelletkaminöfen sind sehr komfortabel."
          icon={<KomfortIcon fontSize="large" />}
          as={`${linkContext}pelletheizsysteme/komfort`}
        />
      </MuiGrid>
    </Wrap>
  );
};

export default ThemeSection;
